
import React from 'react';
import { FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore(rootStore, componentProps), 'facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalStore')
@observer
class FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal extends React.Component {
    render() {
        return <FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal;
